import "./menu.scss";

// import { scrollTop } from "../smooth-scrollbar/smoothscrollBar";

function menu() {
    const menuWrapper = document.querySelector(".menu-wrapper");
    const menuBtn = document.querySelector(".menu-btn");
    const closeWrapper = menuWrapper?.querySelector(".close-wrapper");

    if (!menuWrapper || !menuBtn) return;

    // Toggle Menu
    menuBtn.addEventListener("click", (e) => {
        e.stopPropagation(); // Prevents immediate close if clicking the button
        menuWrapper.classList.toggle("active");
    });

    // Close via Button
    closeWrapper?.addEventListener("click", () => {
        menuWrapper.classList.remove("active");
    });

    // Close when clicking outside (on the overlay)
    document.addEventListener("click", (e) => {
        if (menuWrapper.classList.contains("active") && !menuWrapper.contains(e.target)) {
            menuWrapper.classList.remove("active");
        }
    });


    // Close when clicking outside (on the overlay) and hide classes like d-none and open under header
    document.querySelector('.menu-wrapper').addEventListener('click', function() {
        // Select the specific hidden elements
        const hiddenElements = this.querySelectorAll('.d-none');
        const desktopLinks = document.querySelector('.links.d-desktop');

        // Select the menu icon to remove the open state
        const sMenu = document.querySelector('.s-menu');

        // Toggle for elements inside the wrapper
        hiddenElements.forEach(el => {
            el.classList.toggle('d-none');
        });

        // Toggle for the header links
        if (desktopLinks) {
            desktopLinks.classList.toggle('d-none');
        }

        // Remove the 'open' class from the s-menu
        if (sMenu) {
            sMenu.classList.remove('open');
        }
    });


    // Close menu on ESC key
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") menuWrapper.classList.remove("active");
    });

    const buttons = document.querySelectorAll('.btn');
    if (buttons.length > 0) {
        buttons.forEach(button => {
            if (button.textContent.trim()) {
                const span = document.createElement('div');
                span.textContent = button.textContent;
                button.textContent = '';
                button.appendChild(span);
            }
        });
    }

}

const menuClose = () => {
    const closeBtn = document.getElementById("trigger");
    if (closeBtn) {
        closeBtn.checked = false;
    }
    document.querySelector("header .links").classList.remove("d-none");
     document.querySelector(".s-menu").classList.remove("open")
};


function checkCurrentPage() {
    const currentURL = document.location.href;
    const links = document.querySelectorAll("header a");
    const dropdown = document.querySelectorAll(".hasDropdown");

    links.forEach(link => {
        const isLinkActive = link.href === currentURL;
        link.classList.toggle("active", isLinkActive);
        if (isLinkActive) {
            link.addEventListener("click", e => {
                e.preventDefault();
                // scrollTop();
            });
        }
    });



    dropdown.forEach(element => {
        const el = element.querySelector(".dropdown-menu");
        const subel = el.querySelector("a.active");

        element.classList.toggle("active", subel !== null);

        element.addEventListener("click", () => {
            setTimeout(() => el.classList.add("disappear"), 400);
            setTimeout(() => el.classList.remove("disappear"), 900);
        });
    });
}


function menuAccordian() {
    const subArrow = document.querySelectorAll(".h-sub-menu .dropdown-arrow");
    subArrow.forEach((sarrow) => {
        sarrow.addEventListener("click", function () {
            sarrow.parentNode.classList.toggle("active");
        });
    });
}

function footerMenu() {
    const footers = document.querySelectorAll(".f-menus h6");
    footers.forEach((footer) => {
        footer.addEventListener("click", function () {
            footer.parentNode.classList.toggle("show");
        });
    });
}

function btnSpan(){
     document.querySelector(".menu-btn").addEventListener("click", function () {
        document.querySelector(".s-menu").classList.toggle("open")
        document.querySelector("header .links").classList.toggle("d-none");
    });
}

function hamburg() {
    const trigger = document.getElementById("trigger");
    const body = document.body;
    if (!trigger || !menu) return;

    trigger.addEventListener("change", () => {
        if (trigger.checked) {
            body.classList.add("m-show");
        } else {
            body.classList.remove("m-show");
        }
    });
}

function initMobProjectToggle() {
    const li = document.getElementById("mob-project");
    if (!li) return;

    const link = li.querySelector("a"); // click anywhere on link

    link.addEventListener("click", (e) => {
        e.preventDefault(); // stop #
        li.classList.toggle("show");
    });
}



export {
    initMobProjectToggle,
    hamburg,
    footerMenu,
    menu,
    menuClose,
    checkCurrentPage,
    menuAccordian,
    btnSpan
};
